import { defineComponent as e } from "vue";
import { Remarkable as t } from "remarkable";
const r = new t(), m = e({
  name: "sequiter-markdown",
  props: {
    /**
     * The markdown to convert to html. Supports markdown and prevents HTML tags from rendering as HTML.
     */
    content: {
      type: String,
      required: !0
    }
  },
  computed: {
    /**
     * @returns The html content generated from the provided markdown.
     */
    htmlContent() {
      return r.render(this.content).trim();
    }
  }
});
export {
  m as default
};
//# sourceMappingURL=sequiter-markdown.vue2.js.map
